module.exports = __webpack_public_path__ + "9610d6b7a115fad18c636890ed51770d.MP3";